import {
  ICreateTelehealthSessionRequest,
  ICreateTelehealthSessionResponse,
  IGetTelehealthSessionResponse,
  IPublicTelehealthJoinResponse,
  ITelehealthAssignableProvidersResponse,
  ITelehealthAssignableTechniciansResponse,
  ITelehealthContactInfoResponse,
  ITelehealthController,
  ITelehealthDashboardRequest,
  ITelehealthDashboardResponse,
  ITelehealthLink,
  ITelehealthService,
  ITelehealthSmsOutcomesResponse,
  ITelehealthTokenResponse,
  ITelehealthVisitSessionMapResponse,
  IUpdateTelehealthSessionRequest,
} from "../../core/ports/Telehealth";

export const TelehealthControllerFactory = ({
  telehealthService,
}: {
  telehealthService: ITelehealthService;
}): ITelehealthController => ({
  createSession(
    request: ICreateTelehealthSessionRequest
  ): Promise<ICreateTelehealthSessionResponse> {
    return telehealthService.createSession(request);
  },
  updateSession(
    telehealthSessionId: string,
    request: IUpdateTelehealthSessionRequest
  ): Promise<ICreateTelehealthSessionResponse> {
    return telehealthService.updateSession(telehealthSessionId, request);
  },
  getSessionByVisitNote(
    visitNoteId: number
  ): Promise<IGetTelehealthSessionResponse> {
    return telehealthService.getSessionByVisitNote(visitNoteId);
  },
  getSessionSmsOutcomes(
    telehealthSessionId: string,
    limit?: number
  ): Promise<ITelehealthSmsOutcomesResponse> {
    return telehealthService.getSessionSmsOutcomes(telehealthSessionId, limit);
  },
  listDashboardSessions(
    clinicId: number,
    request?: ITelehealthDashboardRequest
  ): Promise<ITelehealthDashboardResponse> {
    return telehealthService.listDashboardSessions(clinicId, request);
  },
  listAssignableProviders(
    clinicId: number
  ): Promise<ITelehealthAssignableProvidersResponse> {
    return telehealthService.listAssignableProviders(clinicId);
  },
  listAssignableTechnicians(
    clinicId: number
  ): Promise<ITelehealthAssignableTechniciansResponse> {
    return telehealthService.listAssignableTechnicians(clinicId);
  },
  getActiveSessionsByVisitNotes(
    clinicId: number,
    visitNoteIds: number[]
  ): Promise<ITelehealthVisitSessionMapResponse> {
    return telehealthService.getActiveSessionsByVisitNotes(
      clinicId,
      visitNoteIds
    );
  },
  getLatestPatientContact(
    patientId: number
  ): Promise<ITelehealthContactInfoResponse> {
    return telehealthService.getLatestPatientContact(patientId);
  },
  getClinicianToken(
    telehealthSessionId: string
  ): Promise<ITelehealthTokenResponse> {
    return telehealthService.getClinicianToken(telehealthSessionId);
  },
  getOrRotateLink(
    telehealthSessionId: string,
    rotate?: boolean
  ): Promise<ITelehealthLink> {
    return telehealthService.getOrRotateLink(telehealthSessionId, rotate);
  },
  shareLink(
    telehealthSessionId: string,
    request: IUpdateTelehealthSessionRequest
  ): Promise<ICreateTelehealthSessionResponse> {
    return telehealthService.shareLink(telehealthSessionId, request);
  },
  revokeLink(telehealthSessionId: string): Promise<{ success: boolean }> {
    return telehealthService.revokeLink(telehealthSessionId);
  },
  endSession(telehealthSessionId: string): Promise<{ success: boolean }> {
    return telehealthService.endSession(telehealthSessionId);
  },
  getPublicJoin(token: string): Promise<IPublicTelehealthJoinResponse> {
    return telehealthService.getPublicJoin(token);
  },
  getPublicPatientToken(token: string): Promise<ITelehealthTokenResponse> {
    return telehealthService.getPublicPatientToken(token);
  },
  publicPatientLeave(
    token: string,
    participantIdentity: string
  ): Promise<{ success: boolean }> {
    return telehealthService.publicPatientLeave(token, participantIdentity);
  },
});
